import type { IconProp } from '@fortawesome/fontawesome-svg-core'

export const AMENITIES_CATEGORIES = [
  'Accessories',
  'Electronics',
  'Kitchen',
  'Bathroom',
  'Temperature',
  'Other',
] as const
Object.freeze(AMENITIES_CATEGORIES)
export type AMENITIES_CATEGORIES = (typeof AMENITIES_CATEGORIES)[number]

export const ACCESSORIES_AMENITIES = [
  'Awning',
  'Campingchairsprovided',
  'Inverter',
  'LinensProvided',
  'LevelingJacks',
  'Generator',
  'Solar',
  'TowHitch',
] as const
Object.freeze(ACCESSORIES_AMENITIES)
export type ACCESSORIES_AMENITIES = (typeof ACCESSORIES_AMENITIES)[number]

export const ELECTRONICS_AMENITIES = [
  'AuxInput',
  'BackupCamera',
  'CdPlayer',
  'GPSUnitAvailable',
  'Satellite',
  'Radio',
  'TV_DVD',
  'USBInput',
  'WiFi',
] as const
Object.freeze(ELECTRONICS_AMENITIES)
export type ELECTRONICS_AMENITIES = (typeof ELECTRONICS_AMENITIES)[number]

export const KITCHEN_AMENITIES = [
  'Refrigerator',
  'Stove_Range',
  'Microwave',
  'KitchenSink',
  'DiningTable',
  'Freezer',
  'Oven',
] as const
Object.freeze(KITCHEN_AMENITIES)
export type KITCHEN_AMENITIES = (typeof KITCHEN_AMENITIES)[number]

export const BATHROOM_AMENITIES = [
  'InsideShower',
  'OutsideShower',
  'Toilet',
] as const
Object.freeze(BATHROOM_AMENITIES)
export type BATHROOM_AMENITIES = (typeof BATHROOM_AMENITIES)[number]

export const TEMPERATURE_AMENITIES = [
  'AirConditioner',
  'Heater',
] as const
Object.freeze(TEMPERATURE_AMENITIES)
export type TEMPERATURE_AMENITIES = (typeof TEMPERATURE_AMENITIES)[number]

export const OTHER_AMENITIES = [
  'Family_kidfriendly',
  'HandicapAccessible',
  'Vintage',
  'FullWinterRentalAvailable',
  'ExtraStorage',
  'Parking',
] as const
Object.freeze(OTHER_AMENITIES)
export type OTHER_AMENITIES = (typeof OTHER_AMENITIES)[number]

export const AMENITIES = [...ACCESSORIES_AMENITIES, ...BATHROOM_AMENITIES, ...ELECTRONICS_AMENITIES, ...KITCHEN_AMENITIES, ...OTHER_AMENITIES, ...TEMPERATURE_AMENITIES] as const
Object.freeze(AMENITIES)
export type AMENITIES = (typeof AMENITIES)[number]

export const AMENITIES_CATEGORIZED: Record<AMENITIES_CATEGORIES, (typeof ACCESSORIES_AMENITIES) | (typeof BATHROOM_AMENITIES) | (typeof ELECTRONICS_AMENITIES) | (typeof KITCHEN_AMENITIES) | (typeof OTHER_AMENITIES) | (typeof TEMPERATURE_AMENITIES)> = {
  Accessories: ACCESSORIES_AMENITIES,
  Bathroom: BATHROOM_AMENITIES,
  Temperature: TEMPERATURE_AMENITIES,
  Electronics: ELECTRONICS_AMENITIES,
  Kitchen: KITCHEN_AMENITIES,
  Other: OTHER_AMENITIES,
}
Object.freeze(AMENITIES_CATEGORIZED)
export type AMENITIES_CATEGORIZED = keyof typeof AMENITIES_CATEGORIZED

/** Park amenities */
export const PARK_AMENITIES_CATEGORIES = [
  'SportsAndWellness',
  'WaterActivities',
  'FamilyAndEntertainment',
  'Other',
] as const
Object.freeze(PARK_AMENITIES_CATEGORIES)
export type PARK_AMENITIES_CATEGORIES = (typeof PARK_AMENITIES_CATEGORIES)[number]

export const SPORTS_AND_WELLNESS_PARK_AMENITIES = [
  'BasketballCourt',
  'FitnessFacility',
  'GolfNearby',
  'Tennis',
  'Sauna',
] as const
Object.freeze(SPORTS_AND_WELLNESS_PARK_AMENITIES)
export type SPORTS_AND_WELLNESS_PARK_AMENITIES = (typeof SPORTS_AND_WELLNESS_PARK_AMENITIES)[number]

export const WATER_ACTIVITIES_PARK_AMENITIES = [
  'NearBeaches',
  'Boating',
  'BoatDockingAvailable',
  'Fishing',
  'IndoorPool',
  'OutdoorPool',
] as const
Object.freeze(WATER_ACTIVITIES_PARK_AMENITIES)
export type WATER_ACTIVITIES_PARK_AMENITIES = (typeof WATER_ACTIVITIES_PARK_AMENITIES)[number]

export const FAMILY_AND_ENTERTAINMENT_PARK_AMENITIES = [
  'Family_kidfriendly',
  'KidsClub',
  'LiveEntertainment',
  'Restaurantonsite',
] as const
Object.freeze(FAMILY_AND_ENTERTAINMENT_PARK_AMENITIES)
export type FAMILY_AND_ENTERTAINMENT_PARK_AMENITIES = (typeof FAMILY_AND_ENTERTAINMENT_PARK_AMENITIES)[number]

export const OTHER_PARK_AMENITIES = [
  'LaundryAvailable',
  'TuckShop',
  'Wifi',
  'SmokingAllowed',
] as const
Object.freeze(OTHER_PARK_AMENITIES)
export type OTHER_PARK_AMENITIES = (typeof OTHER_PARK_AMENITIES)[number]

export const PARK_AMENITIES = [...SPORTS_AND_WELLNESS_PARK_AMENITIES, ...WATER_ACTIVITIES_PARK_AMENITIES, ...FAMILY_AND_ENTERTAINMENT_PARK_AMENITIES, ...OTHER_PARK_AMENITIES] as const
Object.freeze(PARK_AMENITIES)
export type PARK_AMENITIES = (typeof PARK_AMENITIES)[number]

export const PARK_AMENITIES_CATEGORIZED: Record<PARK_AMENITIES_CATEGORIES, (typeof FAMILY_AND_ENTERTAINMENT_PARK_AMENITIES) | (typeof OTHER_PARK_AMENITIES) | (typeof SPORTS_AND_WELLNESS_PARK_AMENITIES) | (typeof WATER_ACTIVITIES_PARK_AMENITIES)> = {
  SportsAndWellness: SPORTS_AND_WELLNESS_PARK_AMENITIES,
  WaterActivities: WATER_ACTIVITIES_PARK_AMENITIES,
  FamilyAndEntertainment: FAMILY_AND_ENTERTAINMENT_PARK_AMENITIES,
  Other: OTHER_PARK_AMENITIES,
}
Object.freeze(PARK_AMENITIES_CATEGORIZED)
export type PARK_AMENITIES_CATEGORIZED = keyof typeof PARK_AMENITIES_CATEGORIZED

/** Amenities icons **/
type LEGACY_AMENITIES = 'Petfriendly' | 'Vintage' | 'VintageStyle'

export const AMENITIES_ICON_MAP: Record<AMENITIES | LEGACY_AMENITIES | PARK_AMENITIES, IconProp> = {
  // RV amenities
  AirConditioner: 'air-conditioner',
  AuxInput: 'music',
  Awning: 'people-roof',
  BackupCamera: 'camera-security',
  Campingchairsprovided: 'chair',
  CdPlayer: 'compact-disc',
  DiningTable: 'table-picnic',
  ExtraStorage: 'boxes-stacked',
  Family_kidfriendly: 'family-pants',
  Freezer: 'refrigerator',
  FullWinterRentalAvailable: 'snowflakes',
  Generator: 'battery-bolt',
  GPSUnitAvailable: 'compass',
  HandicapAccessible: 'wheelchair',
  Heater: 'heat',
  InsideShower: 'shower',
  Inverter: 'plug-circle-bolt',
  KitchenSink: 'sink',
  LevelingJacks: 'arrows-from-line',
  LinensProvided: 'blanket',
  Microwave: 'microwave',
  OutsideShower: 'shower-down',
  Oven: 'oven',
  Parking: 'circle-parking',
  Petfriendly: 'paw-simple',
  Radio: 'radio',
  Refrigerator: 'refrigerator',
  Satellite: 'satellite-dish',
  Solar: 'solar-panel',
  Stove_Range: 'fire-burner',
  Toilet: 'toilet',
  TowHitch: 'trailer',
  TV_DVD: 'tv-retro',
  USBInput: ['fab', 'usb'],
  Vintage: 'clock-rotate-left',
  VintageStyle: 'clock-rotate-left',
  WiFi: 'wifi', // TODO: combine these two on the backend first
  Wifi: 'wifi',

  // Park amenities
  BasketballCourt: 'basketball',
  Boating: 'sailboat',
  BoatDockingAvailable: 'anchor-circle-check',
  Fishing: 'fishing-rod',
  FitnessFacility: 'dumbbell',
  GolfNearby: 'golf-club',
  IndoorPool: 'water-ladder',
  KidsClub: 'children',
  LaundryAvailable: 'dryer-heat',
  LiveEntertainment: 'microphone-stand',
  NearBeaches: 'umbrella-beach',
  OutdoorPool: 'person-swimming',
  Restaurantonsite: 'plate-utensils',
  Sauna: 'temperature-arrow-up',
  SmokingAllowed: 'smoking',
  Tennis: 'racquet',
  TuckShop: 'store',
} as const
Object.freeze(AMENITIES_ICON_MAP)
export type AMENITIES_ICON_MAP = keyof typeof AMENITIES_ICON_MAP
